import { Platform } from 'react-native';

import { ScrollView, XStack, YStack } from 'tamagui';

import { BodyS, Icon, LabelM, getTestProps } from '@south-street-app/atoms';

type ArchivedChatListRow = {
  id: string;
  title: string;
  dateLabel: string;
  timeLabel: string;
  selected?: boolean;
};

type ArchivedChatsListViewProps = {
  rows: ArchivedChatListRow[];
  onPressRow: (id: string) => void;
};

const pressStyle = { opacity: 0.8 };

const ArchivedChatsListView = ({
  rows,
  onPressRow,
}: ArchivedChatsListViewProps) => {
  if (rows.length === 0) {
    return (
      <YStack
        alignItems={'center'}
        flex={1}
        gap={'$3'}
        justifyContent={'center'}
        padding={'$6'}
      >
        <Icon color={'$mono400'} iconName={'historyIcon'} size={'$8'} />
        <LabelM color={'$mono900'} fontWeight={'$2'}>
          {'No archived chats'}
        </LabelM>
        <BodyS color={'$mono500'} textAlign={'center'}>
          {'Completed trade conversations will appear here.'}
        </BodyS>
      </YStack>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <YStack paddingVertical={'$2'}>
        {rows.map((row, index) => (
          <YStack key={row.id}>
            <XStack
              alignItems={'center'}
              backgroundColor={row.selected ? '$mono200' : undefined}
              gap={'$3'}
              onPress={() => onPressRow(row.id)}
              paddingHorizontal={'$4'}
              paddingVertical={'$3'}
              pressStyle={pressStyle}
              {...(Platform.OS === 'web' ? { cursor: 'pointer' } : undefined)}
              {...getTestProps(`customer-archived-chat-row-${index}`)}
            >
              <YStack
                alignItems={'center'}
                backgroundColor={'$brand500'}
                borderRadius={'$full'}
                height={'$9'}
                justifyContent={'center'}
                width={'$9'}
              >
                <Icon
                  color={'$mono100'}
                  iconName={'southStreetIcon'}
                  size={'$4'}
                />
              </YStack>

              <YStack flex={1} gap={'$0.5'} minWidth={0}>
                <LabelM color={'$mono900'} fontWeight={'$2'} numberOfLines={1}>
                  {row.title}
                </LabelM>
                <BodyS color={'$mono500'}>{row.dateLabel}</BodyS>
              </YStack>

              <XStack alignItems={'center'} gap={'$2'}>
                <BodyS color={'$mono500'} flexShrink={0}>
                  {row.timeLabel}
                </BodyS>
                <Icon
                  color={'$mono400'}
                  iconName={'chevronRightIcon'}
                  size={'$4'}
                />
              </XStack>
            </XStack>

            {index < rows.length - 1 ? (
              <YStack
                borderBottomColor={'$mono300'}
                borderBottomWidth={1}
                marginHorizontal={'$4'}
              />
            ) : null}
          </YStack>
        ))}
      </YStack>
    </ScrollView>
  );
};

export { ArchivedChatsListView };
export type { ArchivedChatListRow, ArchivedChatsListViewProps };
